import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["containerId"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import Script from 'next/script';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export { default as GoogleTagManagerData } from './data';
export default function GoogleTagManager(_ref) {
  let {
      containerId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  if (!containerId) {
    return null;
  }
  return /*#__PURE__*/_jsx(GoogleTagManagerInner, _objectSpread(_objectSpread({
    containerId: containerId
  }, props), {}, {
    "data-id": "google-tag-manager_index_GoogleTagManager_GoogleTagManagerInner"
  }));
}
function GoogleTagManagerInner(_ref2) {
  let {
    containerId,
    auth,
    preview
  } = _ref2;
  const gtmBaseUrl = 'https://www.googletagmanager.com';
  let gtmScriptSrc = "".concat(gtmBaseUrl, "/gtm.js?id=").concat(containerId);
  if (auth) {
    gtmScriptSrc += "&gtm_auth=".concat(auth);
  }
  if (preview) {
    gtmScriptSrc += "&gtm_preview=".concat(preview);
  }
  gtmScriptSrc += "&gtm_cookies_win=x";
  const gtmNoScriptSrc = "".concat(gtmBaseUrl, "/ns.html?id=").concat(containerId);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Script, {
      id: "google-tag-manager-event-gtm-js",
      strategy: "beforeInteractive",
      "data-id": "google-tag-manager_index_GoogleTagManager_Script",
      children: "window.dataLayer = window.dataLayer || [{'gtm.start': new Date().getTime(), event:'gtm.js'}];"
    }), /*#__PURE__*/_jsx(Script, {
      id: "google-tag-manager",
      strategy: "afterInteractive",
      src: gtmScriptSrc,
      "data-id": "google-tag-manager_index_GoogleTagManager_Script_2"
    }), /*#__PURE__*/_jsx("noscript", {
      "data-id": "google-tag-manager_index_GoogleTagManager_noscript",
      children: /*#__PURE__*/_jsx("iframe", {
        title: "Google Tag Manager",
        src: gtmNoScriptSrc,
        height: "0",
        width: "0",
        style: {
          display: 'none',
          visibility: 'hidden'
        },
        "data-id": "google-tag-manager_index_GoogleTagManager_noscript_iframe"
      })
    })]
  });
}